import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
} from "@mui/material";
import { getUser } from "../../services/user.service";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { getRevertedData, updateRevert } from "../../services/reports.service";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { Typography } from "antd";

const Reverted = () => {
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [updatedData, setUpdatedData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("All");
  const [employeeData, setEmployeeData] = useState([]);

  const handleEmployee = (e, v) => {
    setSelectedEmployeeId(v?._id || "All");
  };

  const formatWorkTime = (seconds) => {
    if (seconds < 60) return `${seconds}`;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return hours > 0
      ? `${hours}:${minutes.toString().padStart(2, "0")} hr`
      : `${minutes} min`;
  };

  const fetchRevertedData = async () => {
    try {
      const res = await getRevertedData({ userId: selectedEmployeeId });
      const formatted = res.data.map((e) => ({
        ...e,
        date: dayjs(e.date).format("DD/MM/YYYY"),
        workHours: formatWorkTime(e?.workHours),
      }));
      setData(formatted);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
      fetchRevertedData();
  }, [selectedEmployeeId]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const res = await getUser({isEnabled: true });
        const configData = res.data.data.map((e) => ({
          ...e,
          label: e?.firstName + (e?.lastName ? " " + e.lastName : ""),
        }));
        setEmployeeData([{ label: "All", _id: "All" }, ...configData]);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployeeData();
  }, []);

  const handleEdit = (e) => {
    setSelectedData(e);
    setUpdatedData(e);
    setOpenDrawer(true);
  };

  const handleChange = (_, newValue) => {
    if (newValue) {
      setUpdatedData((prev) => ({
        ...prev,
        status: newValue.id,
      }));
    }
  };

  const handleSubmit = async () => {
    console.log("updatedData", updatedData);
    try {
      const res = await updateRevert(updatedData);
      if (res.error === false) {
        fetchRevertedData();
      }
    } catch (error) {
      console.log(error);
    }
    setOpenDrawer(false);
  };

  const columns = [
    { id: "date", label: "Date" },
    { id: "fullName", label: "Name" },
    { id: "workHours", label: "Work Hours" },
    { id: "notes", label: "Notes" },
    { id: "status", label: "Status" },
  ];

  const options = [
    { id: "Leave", label: "Leave" },
    { id: "Full LOP", label: "Full LOP" },
    { id: "Half LOP", label: "Half LOP" },
    { id: "P", label: "P" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: true,
    isEdit: true,
    isAdmin: true,
  };

  return (
    <div className="app-container">
      <Grid container spacing={4} mb={2} sx={{ width: "100%" }}>
        <Grid item>
          <Autocomplete
            value={
              employeeData.find((e) => e._id === selectedEmployeeId) || null
            }
            options={employeeData}
            onChange={handleEmployee}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Employee" />
            )}
            sx={{ width: 300 }}
          />
        </Grid>
      </Grid>
      <MasterCommonTable
        columns={columns}
        tableConfig={tableConfig}
        data={data}
        handleEdit={handleEdit}
      />
      <Dialog
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Change Status
          <IconButton
            onClick={() => setOpenDrawer(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pb: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                Date
              </Typography>
              <Typography variant="body1" sx={{ color: '#666' }}>
                {selectedData?.date}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                New Status
              </Typography>
              <Autocomplete
                options={options}
                value={
                  options.find(
                    (opt) => opt.label === updatedData?.status
                  ) || null
                }
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" size="small" fullWidth />
                )}
                sx={{ minWidth: 200 }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDrawer(false)}>Cancel</Button>
          <Button className="saveButton" onClick={handleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Reverted;
